import React from 'react';
import styled from 'styled-components';

const FormItemWrapper = (props) => {
  const { children, label, required, name } = props;
  return (
    <StyledFormItemWrapper>
      <StyledLabel htmlFor={name}>
        {label} {required && <Required>*</Required>}
      </StyledLabel>
      {children}
    </StyledFormItemWrapper>
  );
};

const StyledFormItemWrapper = styled.div`
  margin-bottom: 25px;
`;

const StyledLabel = styled.label`
  color: var(--blue-dark);
  display: flex;
  margin-bottom: 5px;
`;

const Required = styled.sup`
  color: var(--red);
  margin-left: 5px;
`;

export default FormItemWrapper;
